import clsx from 'clsx';

const HourLegend = () => (
  <div className="mt-5 flex w-full flex-row pl-[80px]">
    {Array.from({ length: 24 }, (_, i) => {
      return (
        <div
          className="mb-1 ml-1 flex w-8 flex-[0_0_32px] cursor-pointer justify-center rounded text-center first-of-type:ml-0"
          key={i}
        >
          <span
            className={clsx(
              'flex items-center font-montserrat text-[12px]/[16px] text-brand-gray-200',
              (i + 1) % 12 === 0 ? 'font-bold' : 'font-medium',
            )}
          >
            {i % 3 === 0 && i}
          </span>
        </div>
      );
    })}
  </div>
);

export default HourLegend;
